import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logos/AcclymLogo2.svg';
const _hoisted_1 = { class: "LoginHeader" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
            class: "LoginHeader-logo",
            src: _imports_0,
            width: "160",
            fetchpriority: "high"
        }, null, -1)
    ])));
}
